// Base URL de la API desde las variables de entorno.
const API_BASE = import.meta.env.VITE_API_URL

//funcion para solicitar los motivos de atencion a la API, retorne solo los motivos que pueden ser seleccionados por estudiantes
export async function getMotivosEstudiante() {
    try {
        const response = await fetch(`${API_BASE}/service/motivo/`, { credentials: 'include' });
        if (!response.ok) {
            const text = await response.text().catch(() => "<no body>");
            console.error("getMotivosEstudiante: respuesta no OK", response.status, text);
            throw new Error("Error al obtener motivos");
        }

        const contentType = (response.headers.get("content-type") || "").toLowerCase();
        if (!contentType.includes("application/json")) {
            // Si recibimos HTML (p. ej. index.html o página de error), lo loggeamos para diagnosticar
            const text = await response.text().catch(() => "<no body>");
            console.error("getMotivosEstudiante: se esperaba JSON pero el servidor devolvió:", text);
            throw new Error("Respuesta no JSON del servidor");
        }

        const motivos = await response.json();

        // Filtrar los motivos cuyo nombre no sea "Todos"
        const motivosFiltrados = motivos.filter((motivo) => motivo.nombre !== "Todos");

        return motivosFiltrados;
    } catch (error) {
        console.error("getMotivosEstudiante error:", error);
        throw error;
    }
}


//funcion para enviar a la API los datos para crear un ticket
export async function postAtencion(payload) {
    try {
        const response = await fetch(`${API_BASE}/vqueue/tickets/solicitar-ticket/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            credentials: 'include',
        });
        if (!response.ok) {
            throw new Error("Error al enviar atención");
        }
        return await response.json();
    } catch (error) {
        console.error("postAtencion error:", error);
        throw error;
    }
} 

/**
 * GET constantes: consultar estado del ticket
 * - Endpoint: /vqueue/tickets/<id_ticket>
 */
export async function getTicketInfo(id) {
    try {
    const response = await fetch(`${API_BASE}/vqueue/tickets/${id}/`, { credentials: 'include' });
        if (!response.ok) throw new Error("Error al obtener ticket");
        return await response.json();
    } catch (err) {
        console.error("Error en getTicketInfo:", err);
        throw err;
    }
}

/**
 * PUT: salir de la fila
 * - Endpoint: /vqueue/tickets/retiro-fila/<id_ticket>/
 */
export async function leaveQueue(id) {
    try {
        const response = await fetch(`${API_BASE}/vqueue/tickets/retiro-fila/${id}/`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ estado: "retirado" }),
            credentials: 'include',
        });
        if (!response.ok) throw new Error("Error al retirarse de la fila");
        return await response.json(); 
        // { mensaje: "Solicitante retirado de la fila" }
    } catch (err) {
        console.error("Error en leaveQueue:", err);
        throw err;
    }
}